var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-upload-field',{attrs:{"field":_vm.field,"name":_vm.name,"value":_vm.field.value,"resource-slug":_vm.resourceSlug}})}
var staticRenderFns = []

export { render, staticRenderFns }